/*=========================================================================================
  File Name: state.js
  Description: Cart State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

export default {
    restaurants : [],
    currentRestaurantId : null,
    currentWaitingTime : 0,
    currentLocalTime : '',
    waitingTimeRanges : [],
    disabledHours : [],
    restaurantMaps : [
      {id : 1, image : require('@/assets/images/maps/drammen.jpg'), map : 'https://goo.gl/maps/8XbFzHUhpMB2RkEbA'},
      {id : 2, image : require('@/assets/images/maps/asker.png'), map : 'https://goo.gl/maps/jakVS7ToWdzj9E5CA'},
      {id : 3, image : require('@/assets/images/maps/jessheim.jpeg'), map : 'https://goo.gl/maps/VhFosCPAJqXBNKCt9'},
      {id : 4, image : require('@/assets/images/maps/slemmestad.jpeg'), map : 'https://goo.gl/maps/ucS8ppKB1dGdKEk66'},
      {id : 5, image : require('@/assets/images/maps/sandefjord.jpeg'), map : 'https://goo.gl/maps/jzqBFothEHt4QsZ79'}
    ]
}